import { Component, computed, inject, input } from '@angular/core';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { Image } from '../header/header.component';
import { LightboxModule } from 'ng-gallery/lightbox';
import { Gallery, ImageItem } from 'ng-gallery';
import { TranslatePipe } from '@ngx-translate/core';
import { DOMHandlerService } from '../../../services/domhandler.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact-apartment.component.html',
    host: { class: 'block' },
    standalone: true,
    imports: [ContactFormComponent, LightboxModule, TranslatePipe],
})
export class ContactApartmentComponent {
    data = input.required<Contact>();
    domhandler = inject(DOMHandlerService);
    images = computed(() =>
        this.data().gallery.images.map(
            (image) =>
                new ImageItem({
                    src: this.domhandler.getLargestImage(image),
                    thumb: this.domhandler.getSmallestImage(image),
                }),
        ),
    );

    constructor(private gallery: Gallery) {}

    ngOnInit() {
        const galleryRef1 = this.gallery.ref('gallery-1');
        galleryRef1.setConfig({
            loop: true,
            thumbs: true,
        });
        const galleryRef2 = this.gallery.ref('gallery-2');
        galleryRef2.setConfig({
            loop: true,
            thumbs: true,
        });
    }

    getFirstHalfImages() {
        return this.images().slice(0, this.images().length / 2);
    }

    getSecondHalfImages() {
        return this.images().slice(this.images().length / 2);
    }
}

export type Contact = {
    statusText: StatusText;
    contactInfoText: string;
    gallery: {
        images: Image[];
    };
};

export type StatusText = {
    successText: string;
    failureText: string;
};

export enum FormState {
    Idle,
    Submitting,
    Success,
    Invalid,
    Error,
}
